export default __webpack_public_path__ + "static/Cairo-Regular-cc12ed776c104df902f3027cdd82bd2c.ttf";